import script from "./PhoneMyVideosDeep.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMyVideosDeep.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMyVideosDeep.vue?vue&type=style&index=0&id=cade14d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cade14d4"]])

export default __exports__